import CustomAutocomplete, {
  TCustomAutocomplete,
} from "@/components/Form/InputFields/CustomAutocomplete";
import CustomListWithImageButtonForAutocomplete from "@/components/List/CustomListWithImageButtonForAutocomplete";
import { useDialogDispatch } from "@/context/DialogContext";
import {
  CreativeByChannel,
  DisplayCreative,
} from "@/modules/Asset/Creative/asset.interface";
import {
  CreativeViewModal,
  TemplateViewModal,
} from "@/modules/Asset/Creative/ListAsset/AssetTableRow";
import { Channel, TName } from "@/types";
import { Box } from "@mui/material";
import * as React from "react";
import { Control } from "react-hook-form";

export default function CustomAutocompleteWithImageButtonList({
  itemList,
  name,
  loading = false,
  control,
  ...rest
}: CustomAutocompleteWithImageButtonListProps) {
  const { setDialogState } = useDialogDispatch();

  const memoedListObject = React.useMemo(() => {
    const obj: Record<number, CreativeListOption> = {};
    if (itemList) {
      itemList.forEach((item, index) => {
        obj[index] = item;
      });
    }
    return obj;
  }, [itemList]);

  const handleClickOpenImage = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    index: number,
    isTemplateCreative: boolean
  ) => {
    event.stopPropagation();
    const creativeData = memoedListObject[index].creatives;

    setDialogState({
      open: true,
      title: "Creative",
      children: (
        <Box
          sx={{
            display: "flex",
            width: "100%",
            height: "100%",
            justifyContent: "center",
          }}
        >
          {isTemplateCreative ? (
            <TemplateViewModal
              creativeData={creativeData as unknown as DisplayCreative[]}
            />
          ) : (
            <CreativeViewModal creativeData={creativeData} />
          )}
        </Box>
      ),
      styles: {
        ".MuiDialog-paper": {
          maxWidth: "max-content",
          minWidth: isTemplateCreative ? { xs: "auto", md: "800px" } : "auto",
        },
      },
    });
  };

  return (
    <>
      <CustomAutocomplete
        {...rest}
        isCustomList={true}
        isMultiple={true}
        name={name as TName<any>}
        control={control}
        itemList={itemList as unknown as any[]} // it is done so CustomAutocomplete doesn't complain
        virtualize={false}
        loading={loading}
        customList={CustomListWithImageButtonForAutocomplete}
        listboxProps={{
          customProps: {
            handleClickOpenImage,
            list: memoedListObject,
          },
        }}
      />
    </>
  );
}

export type CreativeListOption = {
  label: string;
  value: string;
  creatives: CreativeByChannel<Channel>[];
};
interface CustomAutocompleteWithImageButtonListProps
  extends Omit<TCustomAutocomplete, "itemList"> {
  control: Control<any>;
  name: string;
  itemList: CreativeListOption[];
}
